import { createContext, useEffect, useRef, useState } from "react";
import "../../App.css";
import { useLocation } from "react-router-dom";
import MainContent from "../../components/MainContent";
import { ScopedCssBaseline, ThemeProvider, Alert, Box } from "@mui/material";
import { schedulePageName } from "../../components/PageName";
import { useLazyGetScheduleByScheduleIdQuery } from "../../features/schedule/scheduleSlice";
import {
  useStartMonitoringMutation,
  useStopMonitoringMutation,
} from "../../features/sensors/sensorsSlice";
import { useTranslation } from "react-i18next";
import WorkScheduleHub from "../../features/SignalR/WorkScheduleHub";
import {
  MainContainerDiv,
  MainScrollableDiv,
  RightScrollableDiv,
  ScrollableDiv,
  theme,
} from "./shared/SharedComponents";
import {
  Actions,
  EntryContext,
  EntryStatus,
  ExecuteOnContext,
  initiateEntryContext,
  StateWrapper,
  useSubState,
} from "./shared/State";
import { MapDiv } from "./divs/MapDiv";
import WeatherMonitoringDiv from "./divs/WeatherMonitoringDiv";
import { ConfinedSpaceMonitoringDiv } from "./divs/ConfinedSpaceMonitoringDiv";
import { RealTimeCameraDiv } from "./divs/RealTimeCameraDiv";
import { RealTimeMonitoringWorkDiv } from "./divs/RealTimeMonitoringWorkDiv";

const RealTimePage = () => {
  const getLocation = useLocation();

  const entryStatusRef = useRef(
    initiateEntryContext({
      siteEquipments: [],
      confinedSpaceStatus: {},
      realTimeStatus: {
        total: 4,
        standBy: 2,
        in: 0,
        out: 0,
        inAI: 0,
        outAI: 0,
        workerStatuses: [],
      },
      weatherStatus: {
        location: "Hong Kong Big Tunnel",
      },
      isAllowedCheckIn: false,
    })
  );

  return (
    <EntryContext.Provider value={entryStatusRef.current}>
      <RealTimePageInner />
    </EntryContext.Provider>
  );
};

const RealTimePageInner = () => {
  const { t, i18n } = useTranslation();
  const getLocation = useLocation();
  const entry = getLocation.state?.entry;
  const schedule = getLocation.state?.schedule;
  const workType = schedule.workType;

  console.log("schedule, ", schedule);

  const [getScheduleQuery] = useLazyGetScheduleByScheduleIdQuery();
  const [startMonitoring] = useStartMonitoringMutation();

  const [entryContext, realTimeStatus] = useSubState(EntryContext, (x) => x!);
  const [riskAssessmentStatus, setRiskAssessmentStatus] = useState(schedule.riskAssessmentStatus);

  useEffect(() => {
    var hubFinishers: (() => void)[] = []
    getScheduleQuery({
      id: schedule?.id,
    }).then((respone: any) => {
      entryContext?.update(
        Actions.setSiteEquipments(respone?.data?.siteEquipments)
      );
      entryContext?.update(
        Actions.setWorkers(respone?.data?.workers, schedule)
      );
      entryContext?.update(
        Actions.updateIsAllowedCheckIn(respone?.data?.isAllowedCheckIn)
      );
      setRiskAssessmentStatus(respone?.data?.riskAssessmentStatus);

      if (workType === "Confined Space")
        hubFinishers.push(
          WorkScheduleHub({
            workScheduleId: schedule?.id,
            setWorkScheduleData: (data: string) => {
              if (data.includes("in:")) {
                const parts = data.split(": ");
                const numericValue = Number(parts[1]);
                console.log("in count: ", numericValue);
                entryContext!.update(Actions.updateInCount(numericValue));
              } else if (data.includes("out:")) {
                console.log("out count");
                const parts = data.split(": ");
                const numericValue = Number(parts[1]);
                entryContext!.update(Actions.updateOutCount(numericValue));
              } else if (data.includes("inAI:")) {
                const parts = data.split(": ");
                const numericValue = Number(parts[1]);
                console.log("in AI count:", numericValue);
                entryContext!.update(Actions.updateInAICount(numericValue));
              } else if (data.includes("outAI:")) {
                const parts = data.split(": ");
                const numericValue = Number(parts[1]);
                console.log("out AI count:", numericValue);
                entryContext!.update(Actions.updateOutAICount(numericValue));
              }
            },
          })
        );
    });

    return () => {
      hubFinishers.forEach(x => x())
    }
  }, []);

  return (
    <MainContent type={schedulePageName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline>
          <MainScrollableDiv>
            <MainContainerDiv>
              {/* Risk Assessment Alert */}
              {workType === "Confined Space" && riskAssessmentStatus !== "assessed" && (
                <Box
                  sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 9999,
                    width: "80%",
                    maxWidth: "600px",
                  }}
                >
                  <Alert
                    severity="warning"
                    sx={{
                      fontSize: "1.2rem",
                      padding: "20px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                      borderRadius: "8px"
                    }}
                  >
                    {t("Risk Assessment Not Completed")}  {t("Status")}：{t(riskAssessmentStatus)}
                  </Alert>
                </Box>
              )}

              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 1,
                }}
                onLoad={() => console.log("Map container loaded")}
              >
                <MapDiv />
              </div>
              <ScrollableDiv
                style={{ position: "relative", zIndex: 2 }}
                onLoad={() => console.log("Scrollable content loaded")}
              >
                <WeatherMonitoringDiv />
                {workType === "Confined Space" && (
                  <>
                    <ConfinedSpaceMonitoringDiv />
                    <RealTimeCameraDiv schedule={schedule} />
                  </>
                )}
              </ScrollableDiv>
              <RightScrollableDiv
                style={{ position: "relative", zIndex: 2 }}
                onLoad={() => console.log("Right scrollable content loaded")}
              >
                <RealTimeMonitoringWorkDiv entryId={0} />
              </RightScrollableDiv>
            </MainContainerDiv>
          </MainScrollableDiv>
        </ScopedCssBaseline>
      </ThemeProvider>
    </MainContent>
  );
};

export default RealTimePage;
